import { toast } from '@/components/toast-notifications'
import toArrayOfStrings from '@/utils/to-array-of-string'

const error = {
  state: {
    type: 'notification',
    message: null,
    redirectTo: null
  },
  reducers: {
    setError: (state, { type = 'notification', message, title, persistent, ...rest }) => {
      const isError = type === 'error'
      const isEmpty = !message || !isError
      if (!isEmpty) {
        const fallback = t => t('common.error', 'Error')
        const messages = toArrayOfStrings(message)
        const formatted = messages.map(msg => <div key={JSON.stringify(msg)}>{msg}</div>)
        toast(formatted, {
          title: title || fallback,
          type: 'error',
          autoClose: persistent ? false : undefined,
          ...rest
        })
      }
      return {
        type,
        message,
        ...rest
      }
    },
    clearError: () => ({
      type: 'notification',
      message: null,
      redirectTo: null
    })
  }
}

export default error
